import React from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { getMessage } from 'util/locale';
import classNames from 'classnames';

import COLORS from 'constants/colors';

import {
  getActiveFieldId
} from 'current/selectors';
import {
  getSoilLegendForFieldId
} from 'util/formatters/data-viz/soil';

import RetractableLegend from 'mapping/legends/RetractableLegend';

const baseString = 'vra-soil-legend';
const classString = classNames({
  [`${baseString}`]: true
});
const legendClassString = classNames({
  'vra-overlay-legend__legend': true,
  'vra-overlay-legend__legend--soil': true
});
let SoilLegendContainer = ({
  legend
}) => (
  <section className={classString}>
    <div className={`${baseString}__legend-wrapper`}>
      <RetractableLegend
        className={legendClassString}
        colors={COLORS.soil}
        displayValues={legend.bins}
        isRetractable={true}
        title={getMessage(`${legend.labelKey}--title`)}
      />
    </div>
  </section>
);
SoilLegendContainer = connect(
  (state) => {
    return {
      legend: getSoilLegendForFieldId(state, getActiveFieldId(state))
    };
  }
)(SoilLegendContainer);
SoilLegendContainer.propTypes = {
  legend: propTypes.object
};
export default SoilLegendContainer;
